import React from "react";
import {
  StyledLoadingdiv,
  StyledProgressdiv,
  StyledProgressPercentage,
} from "./ProgressBar.style";

export default function ProgressBarCM(props) {
  return (
    <StyledLoadingdiv>
      <label htmlFor="file"> در حال بارگذاری </label>
      <StyledProgressdiv id="file" value={props.value} max="100" />
      <StyledProgressPercentage>
        {`% ${Math.trunc(props.value)}`}
      </StyledProgressPercentage>
    </StyledLoadingdiv>
  );
}
